import  { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';
import API, { TokenData, UserLogin } from './ReportsAPI';
import moment from 'moment';

type HasAccessFn = (evvent_id: number, a: number)=>boolean;

const UserAuthContext = createContext<{
	login: boolean,
	user: UserLogin["user"],
	access: UserLogin["access"],
	is_admin: boolean,
	hasAccess: HasAccessFn,
	logout: ()=>void,
	refresh: ()=>void,
}>({
	login: false,
	user: null,
	access: null,
	is_admin: false,
	hasAccess: ()=>false,
	logout: ()=>null,
	refresh: ()=>null,
});

export var useUser = () => useContext(UserAuthContext);

export var UserProvider = (props: PropsWithChildren)=>{
	var [user, setUser] = useState<UserLogin>(JSON.parse(localStorage.getItem('user_external_data') || null));
	var [token, setToken] = useState<TokenData>(JSON.parse(localStorage.getItem('user_external_token') || null))
	var now = moment().unix();
	var is_expired = !token || (token.expires<=(now+30));

	var updateData = ()=>{
		try{
			var d = JSON.parse(localStorage.getItem('user_external_data'));
			setUser(d);
			return d as UserLogin;
		}catch(e){}
	}

	var updateToken = ()=>{
		try{
			var d = JSON.parse(localStorage.getItem('user_external_token'));
			setToken(d);
			return d as TokenData;
		}catch(e){}
	}

	var refresh = ()=>{
		API.getLogin(true);
	}

	var hasAccess = (event_id: number, a: number) => {
		if (!user || !user.user|| is_expired) return false;
		if (user.user?.all_access || !!user.user?.admin_id) return true;
		if (user.access && user.access) {
			var user_ev_acc = user.access;
			var ev_acc = user_ev_acc.find(s => s.event_id == event_id);
			return !!ev_acc && ev_acc.access.indexOf(a) != -1;
		}
		return false;
	}

	var logout = ()=>{
		API.logout();
	}

	useEffect(()=>{
		refresh();
		window.addEventListener('user_external_data', updateData);
		window.addEventListener('user_external_token', updateToken);
		return ()=>{
			window.removeEventListener('user_external_data', updateData);
			window.removeEventListener('user_external_token', updateToken);
		}
	}, [])
	
	return <UserAuthContext.Provider value={{
		login: !is_expired && !!user,
		user: is_expired ? null : user?.user,
		access:  is_expired ? null : user?.access,
		is_admin: !!user?.user?.all_access || !!user?.user?.admin_id,
		hasAccess,
		logout,
		refresh,
	}}>
		{props.children}
	</UserAuthContext.Provider>
}